import React, { } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import { Divider } from '@lockerpm/design';

import { } from "@ant-design/icons";

import commonComponents from "../../../components/common";

import Import from "./components/import-export/Import";
import Export from "./components/import-export/Export";

import global from "../../../config/global";

const ImportExport = () => {
  const { PageHeader } = commonComponents;
  const { t } = useTranslation();
  const locale = useSelector((state) => state.system.locale)

  return (
    <div className="import-export layout-content">
      <PageHeader
        title={t('import_export.title')}
        subtitle={t('import_export.description')}
        docLabel={t('import_export.doc')}
        docLink={global.urls.DOC_LINKS[locale].WS_SETTINGS_IMPORT_EXPORT}
        actions={[]}
      />
      <Import
        className="mt-4"
      />
      <Divider />
      <Export
        className=""
      />
    </div>
  );
}

export default ImportExport;